import { render } from "./FavouritesCount.vue?vue&type=template&id=733df5fc&scoped=true"
import script from "./FavouritesCount.vue?vue&type=script&lang=js"
export * from "./FavouritesCount.vue?vue&type=script&lang=js"

import "./FavouritesCount.vue?vue&type=style&index=0&id=733df5fc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-733df5fc"

export default script